const CartonomyDbName = 'CartonomyDatabase';

export class DbStorageService {
    static $inject = ['cartonomyConfig'];

    constructor(cartonomyConfig) {
        this.cartonomyConfig = cartonomyConfig;

        const indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB || window.shimIndexedDB;

        // Open (or create) the database
        const open = indexedDB.open(`${this.cartonomyConfig.externalStoreUrl}_${CartonomyDbName}`, 1);

        // Create the schema
        open.onupgradeneeded = function () {
            let db = open.result;
            let userauthenticationStore = db.createObjectStore("AuthenticationStore", {keyPath: "token"});
            userauthenticationStore.createIndex("AuthenticationStoreIndex", ['token']);

            let store = db.createObjectStore("WindowState", {keyPath: "id"});
            let index = store.createIndex("NameIndex", ["name.last", "name.first"]);
        };

        open.onsuccess = function () {
            let db = open.result;

            /*
            let tx = db.transaction("MyObjectStore", "readwrite");
            let store = tx.objectStore("MyObjectStore");
            let index = store.index("NameIndex");

            // Add some data
            store.put({id: 12345, name: {first: "John", last: "Doe"}, age: 42});
            store.put({id: 67890, name: {first: "Bob", last: "Smith"}, age: 35});

            // Query the data
            let getJohn = store.get(12345);
            let getBob = index.get(["Smith", "Bob"]);

            getJohn.onsuccess = function () {
                console.log(getJohn.result.name.first);  // => "John"
            };

            getBob.onsuccess = function () {
                console.log(getBob.result.name.first);   // => "Bob"
            };

            // Close the db when the transaction is done
            tx.oncomplete = function () {
                db.close();
            };

            */
        };

        this.database = open;
    }
}


// WEBPACK FOOTER //
// ./src/modules/shared/services/DbStorageService.js